<template>
  <footer class="main-footer">
    <div class="footer-credit">
      <a href="#"> Designed & Built by Soumyadip Hazra </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PortfolioFooter'
}
</script>

<style scoped>
</style>
